<template>
  <TTitle
    :title="$translation($websiteText().product_details_header_sold_item)"
    v-if="$store.getters.productDetailsInfos.availibilityId == 1"
  ></TTitle>
  <TTitle 
    :title="$translation($websiteText().product_details_header)" 
    v-else
  ></TTitle>

  <div class="containerr">
    <div class="product-details-container">
      <product-detail-form></product-detail-form>
    </div>
  </div>
</template>

<script>
import ProductDetailForm from "../../../domains/product-details/components/productDetailsForm.vue";
import TTitle from "../../../common/components/layouts/header/TTitle.vue";
import { KIT_REGISTER_VIEWER } from "../store/actions";

export default {
  components: {
    ProductDetailForm,
    TTitle,
  },

  setup() {},

  mounted() {
    var that = this;
    this.$store
      .dispatch("displayProductDetails1", {
        option: true,
        id: this.$route.params.id,
      })
      .then(() => {
        that.$store.dispatch("setMainImage");
      });
    if(this.$store.getters.isAuthenticated){
      this.$store.dispatch(KIT_REGISTER_VIEWER, this.$route.params.id)
    }

    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.containerr {
  padding: 15px;
  background-color: $background-color;
  max-width: 1920px;
  margin: auto;

  .product-details-container {
    
    background-color: $background-color;
    margin: auto;
  }
}
</style>
